import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Host,
  Inject,
  forwardRef
} from '@angular/core';
import { DurationPickerComponent } from './duration-picker.component';

@Component({
  selector: 'duration-picker-unit',
  template: `
    <div style="display: flex;align-items: center; padding: 5px;">
      <nz-input-number
        [(ngModel)]="value"
        (ngModelChange)="updateValue()"
        type="number"
        [nzMin]="min"
        [nzMax]="max"
        [nzStep]="step"
      >
      </nz-input-number>
      <span style="padding: 0px 10px" *ngIf="label">{{ label }}</span>
    </div>
  `
})
export class DurationPickerUnitComponent implements OnInit {
  @Input() name: string;
  @Input() label: string;
  @Input() max: number;
  @Input() min: number;
  @Input() step: number;

  @Output() OnChange: EventEmitter<number>;

  value: number;

  constructor(
    @Host()
    @Inject(forwardRef(() => DurationPickerComponent))
    public timeDurationPicker: DurationPickerComponent
  ) {
    this.OnChange = new EventEmitter();
    this.value = 0;
  }

  ngOnInit() {
    this.name = this.name.toLocaleLowerCase();
    const supportedUnitsNames = Object.keys(
      this.timeDurationPicker.supportedUnits
    );
    if (supportedUnitsNames.indexOf(this.name) === -1) {
      throw new Error('Unsupported unit: ' + this.name);
    }
    if (this.label == null) {
      this.label = this.name.charAt(0).toUpperCase() + this.name.slice(1);
    }
    if (this.step == null) {
      this.step = 1;
    }
    if (this.min == null) {
      this.min = this.timeDurationPicker.supportedUnits[this.name].min;
    }
    if (this.max == null) {
      this.max = this.timeDurationPicker.supportedUnits[this.name].max;
    }
  }

  public updateValue() {
    this.OnChange.emit(this.getValue());
    this.timeDurationPicker.updateValue();
  }

  public getValue(): number {
    return this.value;
  }
}
